import { Button, message, Modal, Select, Space, Spin, Table, TableColumnsType, TableProps, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Option,
  Filter,
  MONTH_MAP,
  OptionFilter,
  SummaryVocEmission,
  TankVocEmission,
  UnitTankVoc,
  ResponseAPI,
} from "src/entity/tank/tank.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { getOptionMonthSubmit, getOptions, getReportVocEmission, submitReportVoc, updateApproveStep } from "src/services/tank.service";
import { companyStore } from "src/stores/company-store";
import { profileStore } from "src/stores/profile-store";
import { tankStore } from "src/stores/tank-store";
import { useShallow } from "zustand/react/shallow";
import { canApproveAndViewTable, roleCompanyAdmin } from "../../PermissionCheck/PermissionCheck";
import { UnitAllEnum } from "src/entity/common/unit.constant";
import { formatNumber, parseAndFormatScientificNumber, parseToFixedDecimalWithComma } from "src/utils/process-number";
import { TbRefresh } from "react-icons/tb";
import { BsTable } from "react-icons/bs";
import { componentPalette } from "src/theme/component-palette";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { PiChartBarFill } from "react-icons/pi";
import { settingStore } from "src/stores/setting-store";
import { excelStore } from "src/stores/excel-store.interface";
import ModalApproveMonth from "src/components/ModalApproveMonth/ModalApproveMonth";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import axios from "axios";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ModalApproveStep from "src/components/ModalApproveStep/ModalApproveStep";
import { ApproveBody, DataApprove, initWidthCol, OptionApproval, WidthCol, WidthColTank } from "src/entity/voc-approve/voc-approve.entity";
import { generateYearArray } from "src/utils/array";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";
import { min } from "lodash";
import { FaTextWidth } from "react-icons/fa";
import { utilsStore } from "src/stores/utils-store";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];
const { Text } = Typography;

const ReportVocEmission = () => {
  const menu = "tank";
  const { permissions } = useNavigationMenu();
  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const [messageApi, contextHolder] = message.useMessage();
  const userId = profile?.userId;
  const email = profile?.email;
  const name = profile?.name;

  const [searchParams] = useSearchParams();
  const yearParam = searchParams.get("year");
  const monthParam = searchParams.get("month");
  const approveNoParam = searchParams.get("approveNo");
  const companyParam = searchParams.get("companyId");
  const prevCompanyIdRef = useRef<string | null>(null);

  const [optionYears, setOptionYears] = useState<number[]>([]);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState<Filters>({});
  const [optionsFilter, setOptionFilter] = useState<OptionFilter[]>([]);
  const [data, setData] = useState<TankVocEmission[]>([]);
  const [selectedUnit, setSelectedUnit] = useState<string>(UnitAllEnum.KG);
  const [dataAllUnit, setDataAllUnit] = useState<UnitTankVoc>();
  const [summary, setSummary] = useState<SummaryVocEmission[]>();
  const [selectedButton, setSelectedButton] = useState<string>("table");
  const [selectedEmission, setSelectedEmission] = useState<string>("tvoc");
  const [optionEmissions, setOptionEmissions] = useState<Option[]>([]);
  const [openModalApproveMonth, setOpenModalApproveMonth] = useState<boolean>(false);
  const [optionMonth, setOptionMonth] = useState<Option[]>([]);
  const [openModalApproveStep, setOpenModalApproveStep] = useState<boolean>(false);
  const [approveData, setApproveData] = useState<DataApprove | null>(null);

  // For new ui approval page
  const [selectedYearApprove, setSelectedYearApprove] = useState<number | null>();
  const [selectedMonthApprove, setSelectedMonthApprove] = useState<string | null>();
  const [selectedNoApprove, setSelectedNoApprove] = useState<number | null>();
  const [optionApproval, setOptionApproval] = useState<OptionApproval | null>();
  const [selectedApprove, setSelectedApprove] = useState<string>();
  const [widthTotal, setWidthTotal] = useState<string>("");
  const [widthCol, setWidthCol] = useState<WidthCol>(initWidthCol);
  const [widthMainColumns, setWidthMainColumnsl] = useState<WidthColTank>({});

  const months = MONTH_MAP;

  const getTextWidth = utilsStore(useShallow((state) => state.getTextWidth));

  const excelSetSelectedYear = excelStore(useShallow((state) => state.setSelectedYear));
  const excelSetQueryStr = excelStore(useShallow((state) => state.setQueryStr));

  const emissionMaster = settingStore(useShallow((state) => state.emission));
  const getEmission = settingStore(useShallow((state) => state.getEmission));

  const getAreaByCompanyId = companyStore(useShallow((state) => state.getAreaByCompanyId));
  const areaMaster = companyStore(useShallow((state) => state.dataArea));

  const getTankTypeMaster = tankStore(useShallow((state) => state.getTankType));
  const tankTypeMaster = tankStore(useShallow((state) => state.tankType));

  const getTankEmissionControlMaster = tankStore(useShallow((state) => state.getTankEmissionControl));
  const tankEmissionControlMaster = tankStore(useShallow((state) => state.tankEmissionControl));

  const warningAlert = (message: string | string[], action: string) => {
    const warnModal = Modal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not {action}</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: message,
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    if (!yearParam) {
      setSelectedYear(years?.[0] as number);
    }
  };

  const fetchReportVocEmission = async () => {
    try {
      if (selectedYear) {
        setLoading(true);
        const queryParam = createParamFilter();
        let response = await getReportVocEmission(queryParam);
        if (response.data.code === 200) {
          setLoading(false);
          setDataAllUnit({ ...response.data.data });
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMaster = async () => {
    await getEmission({ type: "global", label: "Emission" });
  };

  const fetchInfoStepApprove = async () => {
    try {
      if (selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
        setLoading(true);
        const query = new URLSearchParams({
          menu,
          year: selectedYearApprove.toString(),
          month: selectedMonthApprove,
          approveNo: selectedNoApprove.toString(),
        }).toString();

        // Fetch data from the API
        const response = await getInfoStepApproval(query);

        if (response.data.code === 200) {
          const approveInfo = response.data.data;

          setApproveData(approveInfo);
          setSelectedApprove(approveInfo._id || "");
        }
      } else {
        resetApprovalState();
      }
    } catch (error) {
      console.error("Error fetching approval data:", error);
      resetApprovalState();
    } finally {
      setLoading(false);
    }
  };

  const resetApprovalState = () => {
    setApproveData(null);
    setSelectedApprove("");
  };

  const fetchOptionVocApprove = async () => {
    try {
      if (yearParam && !selectedYearApprove && !selectedMonthApprove) return;
      const queryParams = new URLSearchParams({ menu });
      if (selectedYearApprove) {
        queryParams.append("year", selectedYearApprove.toString());
      }
      if (selectedMonthApprove) {
        queryParams.append("month", selectedMonthApprove);
      }

      const queryString = queryParams.toString();

      const response = await getOptionVocApproval(queryString);

      if (response.data.code === 200) {
        const { approveNo, year, month } = response.data.data || {};
        setOptionApproval({ ...response.data.data });

        if (approveNo) {
          if (!selectedNoApprove && selectedMonthApprove && selectedYearApprove && approveNo?.length === 1) {
            setSelectedNoApprove(approveNo[0]);
          }
        } else {
          resetSelections();
        }
      } else {
        resetSelections();
      }
    } catch (error) {
      console.error(error);
      resetSelections();
    } finally {
    }
  };

  const resetSelections = () => {
    setOptionApproval(null);
    setSelectedYearApprove(null);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const fetchMonthOfSubmit = async () => {
    try {
      if (selectedYear) {
        setFilterLoading(true);
        const response = await getOptionMonthSubmit(selectedYear);
        if (response.data.code === 200) {
          const month = response.data.data;
          setOptionMonth(month);
        } else {
          setOptionMonth([]);
        }
      }
    } catch (error) {
      console.error(error);
      setOptionMonth([]);
    } finally {
      setFilterLoading(false);
    }
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleYearApproveChange = (value: number) => {
    setSelectedYearApprove(value);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const handleMonthApprovalChange = (value: string) => {
    setSelectedMonthApprove(value);
    setSelectedNoApprove(null);
  };

  const handleApproveNoChange = (value: number) => {
    setSelectedNoApprove(value);
  };

  const handleButtonMenuClick = (buttonName: string) => {
    setSelectedButton(buttonName);
    if (buttonName === "table") {
      setOpenModalApproveStep(false);
      if (yearParam && monthParam && approveNoParam) {
        searchParams.delete("yearParam");
        searchParams.delete("monthParam");
        searchParams.delete("approveNoParam");
        searchParams.delete("companyId");
      }
    } else if (buttonName === "approve") {
      fetchOptionVocApprove();
      setOpenModalApproveStep(true);
      if (yearParam) setSelectedYearApprove(Number(yearParam));
    }
  };

  const handleOpenModalApproveMonth = () => {
    setOpenModalApproveMonth(true);
  };

  const handleApproveReport = async (approveBody: ApproveBody, action: string) => {
    try {
      setLoading(true);
      const response = await updateApproveStep(approveBody);
      setLoading(false);

      if (response.data.code == 200) {
        if (action === "approved") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.APPROVED_SUCCESSFULL,
          });
        } else if (action === "reject") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.REJECT_SUCCESSFULL,
          });
        }
        await fetchInfoStepApprove();
        await fetchMonthOfSubmit();
      } else {
        messageApi.open({
          type: "error",
          content: CommonError.APPROVED_FAIL,
        });
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        const actionStr = action === "approved" ? "approve" : "reject";
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), actionStr);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getColumnLabel = (column: string): string => {
    const labels: Record<string, string> = {
      tankId: "Tank ID",
      area: "Area ",
      chemicalName: "Chemical Name",
      tankType: "Tank Type",
      emission: "Emission",
      unit: "Unit",
    };
    return labels[column] || "";
  };

  const getMainColumnsWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMainColumns: { [key in keyof TankVocEmission]: string } = {} as any;
    const mainColumns = ["tankId", "area", "chemicalName", "tankType", "emission", "unit"];

    if (data && data.length > 0) {
      mainColumns.forEach((column) => {
        let max = 0;

        data.forEach((row) => {
          let value = row[column as keyof TankVocEmission];
          if (column === "area") {
            value = getMasterLabel("area", row[column]);
          } else if (column === "tankType") {
            value = getMasterLabel("tankTypeId", row[column]);
          }
          const text = String(value);
          const textWidth = getTextWidth(text, font);
          if (textWidth > max) max = textWidth;
        });

        const overrideWidths: Record<string, number> = {
          tankType: 100,
          chemicalName: 120,
        };
        const label = getColumnLabel(column);
        let labelWidth = overrideWidths[column] ?? getTextWidth(label, font);
        if (labelWidth > max) max = labelWidth;

        if (max < 50) max = 100;
        widthMainColumns[column as keyof typeof widthMainColumns] = `${max * 1.1}px`;
      });
    }
    setWidthMainColumnsl(widthMainColumns);
  };

  const getWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMonth: { [key in keyof SummaryVocEmission]: string } = {} as any;
    months.forEach((month) => {
      const keyMonth = month.dataIndex as keyof SummaryVocEmission;

      const widthAb = summary?.[0]?.[keyMonth] || "";
      const widthIn = summary?.[1]?.[keyMonth] || "";

      const textWidthAb = getTextWidth(String(widthAb), font);
      const textWidthIn = getTextWidth(String(widthIn), font);

      let maxWidth = Math.max(textWidthAb, textWidthIn);

      if (maxWidth < 90) {
        maxWidth = 90;
      }

      widthMonth[keyMonth] = `${maxWidth}px`;
    });
    setWidthCol(widthMonth);
    const widthTotalAb = summary?.[0]?.total || "";
    const widthTotalIn = summary?.[1]?.total || "";
    const textWidthTotalAb = getTextWidth(String(widthTotalAb), font);
    const textWidthTotalIn = getTextWidth(String(widthTotalIn), font);
    let maxWidthTotal = Math.max(textWidthTotalAb, textWidthTotalIn);
    if (maxWidthTotal == 0) {
      maxWidthTotal = 100;
    }
    setWidthTotal(`${maxWidthTotal}px`);
  };

  const buttonStyle = (buttonName: string) => ({
    backgroundColor: selectedButton === buttonName ? componentPalette.primary : "initial",
    color: selectedButton === buttonName ? "white" : "initial",
  });

  const fetchOption = async () => {
    try {
      if (selectedYear) {
        const response = await getOptions(selectedYear);
        if (response.data.code === 200) {
          const data = response.data.data.filter;
          setOptionFilter(data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeUnit = () => {
    if (selectedUnit === UnitAllEnum.KG) {
      setSelectedUnit(UnitAllEnum.TON);
    } else if (selectedUnit === UnitAllEnum.TON) {
      setSelectedUnit(UnitAllEnum.KG);
    }
  };

  const handleSubmitReport = async (checkMonths: any) => {
    try {
      if (userId) {
        const payload = {
          userId: userId,
          months: checkMonths,
          year: selectedYear,
        };
        setLoading(true);
        const response = await submitReportVoc(payload);
        if (response.data.code === 200) {
          setOpenModalApproveMonth(false);
          messageApi.open({
            type: "success",
            content: CommonSuccess.SUBMIT_SUCCESSFULL,
          });
          fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), "submit");
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeEmission = (value: string) => {
    setSelectedEmission(value);
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    queryParam += `&emission=${selectedEmission}`;
    queryParam += `&unit=${selectedUnit}`;

    if (filter) {
      const str = Object.entries(filter)
        .filter(([, value]) => value)
        .map(([key, value]) => `&${key}=[${value?.join(",")}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const onTableChange: TableProps["onChange"] = (pagination: any, filters: any) => {
    let current = pagination.current;
    setFilter(filters);
    setCurrent(current);
  };

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return "";
    if (type === "area" && areaMaster) {
      const optValue = areaMaster.find((item) => item._id === text);
      return optValue?.areaName;
    } else if (type === "tankTypeId") {
      const optValue = tankTypeMaster.find((item) => item._id === text);
      return optValue?.tankType;
    } else if (type === "emissionControlId" && tankEmissionControlMaster) {
      const optValue = tankEmissionControlMaster.find((item) => item._id === text);
      return optValue?.emissionControl;
    } else if (type === "efficiency") {
      const optValue = tankEmissionControlMaster.find((item) => item._id === text);
      return optValue?.efficiency;
    } else {
      return text;
    }
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = value;
        if (key === "area") {
          text = getMasterLabel("area", text);
        } else if (key === "tankTypeId") {
          text = getMasterLabel("tankTypeId", text);
        } else if (key === "emissionControlId") {
          text = getMasterLabel("emissionControlId", text);
        } else if (key === "efficiency") {
          text = getMasterLabel("efficiency", text);
        }
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const getRowSpan = (index: number, record: any, dataTable: any[]) => {
    if (index === 0 || dataTable[index - 1]._id !== record._id) {
      return dataTable.filter((item) => item._id === record._id).length;
    }
    return 0;
  };

  const isDisableSubmitButton = () => {
    if (!canApproveAndViewTable(permissions) || data?.length == 0 || optionMonth.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const removeSarchParam = () => {
    searchParams.delete("year");
    searchParams.delete("month");
    searchParams.delete("approveNo");
    searchParams.delete("companyId");
  };

  const resetFilter = () => {
    setFilter({});
  };

  useEffect(() => {
    getWidth();
  }, [summary]);

  useEffect(() => {
    getMainColumnsWidth();
  }, [data]);

  useEffect(() => {
    fetchMaster();
    if (profile?.activeCompany._id) {
      fetchYear();
    }
  }, []);

  useEffect(() => {
    if (!profile?.activeCompany) return;
    const companyId = profile.activeCompany._id;
    if (prevCompanyIdRef.current === companyId) return;
    prevCompanyIdRef.current = companyId;

    setSelectedYear(currentYear);
    resetFilter();
    if (yearParam && monthParam && approveNoParam) {
      if (companyId === companyParam) {
        handleButtonMenuClick("approve");
        if (yearParam) setSelectedYearApprove(Number(yearParam));
        if (monthParam) setSelectedMonthApprove(monthParam);
        if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
        removeSarchParam();
      }
    } else if (yearParam) {
      // Case: Redirected from "My Task" to the VOC Emission report with only the year parameter
      if (yearParam) {
        setSelectedYear(Number(yearParam));
      }
      if (Number(yearParam) === Number(selectedYear)) {
        searchParams.delete("year");
      }
    } else {
      setSelectedYearApprove(null);
      setSelectedMonthApprove(null);
      setSelectedNoApprove(null);
    }

    const fetchData = async () => {
      await Promise.all([fetchMaster(), getAreaByCompanyId(companyId), fetchMonthOfSubmit(), fetchOptionVocApprove()]);
    };

    fetchData();
  }, [profile?.activeCompany]);

  useEffect(() => {
    if (loadingProfile === true) {
      setLoading(true);
    }
  }, [loadingProfile]);

  useEffect(() => {
    resetFilter();
    if (selectedYear) {
      excelSetSelectedYear(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    fetchOptionVocApprove();
    fetchInfoStepApprove();
  }, [selectedYearApprove, selectedMonthApprove, selectedNoApprove]);

  useEffect(() => {
    const queryParam = createParamFilter();
    if (queryParam) {
      excelSetQueryStr(queryParam);
    }
    fetchReportVocEmission();
    fetchOption();
    fetchMonthOfSubmit();
    fetchInfoStepApprove();
  }, [current, filter, selectedEmission, selectedUnit]);

  useEffect(() => {
    if (dataAllUnit && selectedUnit) {
      const dataUnitSelected = dataAllUnit[selectedUnit];
      if (dataUnitSelected) {
        setData(dataUnitSelected.data);
        setSummary(dataUnitSelected.summary);
      }
    }
  }, [dataAllUnit, selectedUnit]);

  useEffect(() => {
    if (emissionMaster[0] && emissionMaster[0].options) {
      const optEmission = [...emissionMaster[0].options];
      setOptionEmissions(optEmission);
    }
  }, [emissionMaster]);

  const totalColumns: TableColumnsType<TankVocEmission> = [
    {
      title: "Total",
      dataIndex: "total",
      width: widthTotal,
      render: (value) => {
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : <Text>{0}</Text>;
        } else {
          return <Text>{0}</Text>;
        }
      },
    },
  ];

  const monthColumns: TableColumnsType<TankVocEmission> = months.map((month) => ({
    title: month.title,
    width: widthCol[month.dataIndex as keyof WidthCol],
    render: (_, record) => {
      if (record && typeof record === "object") {
        const value = record[month.dataIndex];
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : <Text>{0}</Text>;
        } else {
          return <Text>{0}</Text>;
        }
      }
    },
  }));

  const staticColumns: TableColumnsType<TankVocEmission> = [
    {
      title: "No",
      dataIndex: "no",
      width: 50,
      render: (text) => <Text>{text}</Text>,
      // render: (text, record, index) => {
      //   const rowSpan = getRowSpan(index, record, data);
      //   return {
      //     children: <Text>{text}</Text>,
      //     props: {
      //       rowSpan,
      //     },
      //   };
      // },
    },
    {
      title: "Tank ID",
      dataIndex: "tankId",
      width: widthMainColumns?.tankId,
      filteredValue: filter?.tankId || null,
      filters: mapFilter("tankId"),
      render: (text) => <Text>{text}</Text>,
      // render: (text, record, index) => {
      //   const rowSpan = getRowSpan(index, record, data);
      //   return {
      //     children: <Text>{text}</Text>,
      //     props: {
      //       rowSpan,
      //     },
      //   };
      // },
    },
    {
      title: "Area",
      dataIndex: "area",
      width: widthMainColumns?.area,
      key: "area",
      filteredValue: filter?.area || null,
      filters: mapFilter("area"),
      render: (text) => <Text>{getMasterLabel("area", text)}</Text>,
      // render: (text, record, index) => {
      //   const rowSpan = getRowSpan(index, record, data);
      //   return {
      //     children: <Text>{getMasterLabel("area", text)}</Text>,
      //     props: {
      //       rowSpan,
      //     },
      //   };
      // },
    },
    {
      title: "Chemical Name",
      dataIndex: "chemicalName",
      width: widthMainColumns?.chemicalName,
      filteredValue: filter?.chemicalName || null,
      filters: mapFilter("chemicalName"),
      render: (text) => <Text>{text}</Text>,
      // render: (text, record, index) => {
      //   const rowSpan = getRowSpan(index, record, data);
      //   return {
      //     children: <Text>{text}</Text>,
      //     props: {
      //       rowSpan,
      //     },
      //   };
      // },
    },
    {
      title: "Tank Type",
      dataIndex: "tankType",
      key: "tankTypeId",
      width: widthMainColumns?.tankType,
      filteredValue: filter?.tankTypeId || null,
      filters: mapFilter("tankTypeId"),
      render: (text) => <Text>{getMasterLabel("tankTypeId", text)}</Text>,
      // render: (text, record, index) => {
      //   const rowSpan = getRowSpan(index, record, data);
      //   return {
      //     children: <Text>{getMasterLabel("tankTypeId", text)}</Text>,
      //     props: {
      //       rowSpan,
      //     },
      //   };
      // },
    },
    {
      title: "Emission",
      dataIndex: "emission",
      key: "emission",
      width: widthMainColumns?.emission,
      render: (text) => <Text>{text === "tvoc" ? "TVOCs" : text.toUpperCase()}</Text>,
    },
    {
      title: (
        <>
          <Space>
            Unit
            <Button onClick={handleChangeUnit} type="text" icon={<TbRefresh />} />
          </Space>
        </>
      ),
      dataIndex: "unit",
      width: widthMainColumns?.unit,
      render: (text) => <Text>{text}</Text>,
    },
  ];

  const columns: TableColumnsType<TankVocEmission> = [...staticColumns, ...monthColumns, ...totalColumns];
  return (
    <>
      {contextHolder}
      <div style={{ display: "flex", paddingBottom: "10px", gap: "20px", position: "relative" }}>
        <div>
          <div style={{ display: "flex", gap: "20px" }}>
            {selectedButton === "table" ? (
              <Select
                value={selectedYear}
                style={{ width: 120 }}
                onChange={handleYearChange}
                options={optionYears.map((year) => ({ label: year, value: year }))}
                loading={loading}
                size="middle"
              />
            ) : (
              <div style={{ display: "flex", gap: "10px" }}>
                <Select
                  value={selectedYearApprove}
                  style={{ width: 120 }}
                  onChange={handleYearApproveChange}
                  options={optionApproval?.year?.map((year) => ({ label: year, value: year }))}
                  loading={loading}
                  size="middle"
                />
                <Select
                  value={selectedMonthApprove}
                  style={{ width: 120 }}
                  onChange={handleMonthApprovalChange}
                  options={optionApproval?.month?.map((month) => ({ label: month.charAt(0).toUpperCase() + month.slice(1), value: month }))}
                  loading={loading}
                  size="middle"
                />
                <Select
                  value={selectedNoApprove}
                  style={{ width: 120 }}
                  onChange={handleApproveNoChange}
                  options={optionApproval?.approveNo?.map((approveNo) => ({ label: approveNo, value: approveNo }))}
                  loading={loading}
                  size="middle"
                />
              </div>
            )}

            {/* Emission Select */}
            {selectedButton === "table" && (
              <Select
                value={selectedEmission}
                style={{
                  width: 120,
                  visibility: selectedButton === "table" ? "visible" : "hidden",
                }}
                onChange={handleChangeEmission}
                options={optionEmissions}
                loading={loading}
                size="middle"
              />
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            size="middle"
            style={buttonStyle("table")}
            icon={<BsTable style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("table")}
          />
          <Button
            size="middle"
            style={buttonStyle("chart")}
            icon={<PiChartBarFill style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("chart")}
          />
          <Button
            size="middle"
            style={buttonStyle("approve")}
            icon={<HiOutlineClipboardDocumentCheck style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("approve")}
          />
        </div>
      </div>

      {selectedButton === "table" && (
        <Table
          className="w-full"
          style={{ whiteSpace: "nowrap" }}
          dataSource={canApproveAndViewTable(permissions) ? data : []}
          columns={addCenterAlign(columns)}
          onChange={onTableChange}
          scroll={{ x: "max-content", y: data ? (data?.length === 0 ? undefined : 500) : undefined }}
          loading={loading || filterLoading}
          pagination={false}
          rowKey={(record, index) => `${record._id}-${index}`}
          summary={(pageData) => {
            // console.log("summary", summary);
            if (pageData.length > 0) {
              return (
                <Table.Summary fixed="bottom">
                  {summary?.map((row, index) => (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={index} colSpan={6}>
                        <div style={{ textAlign: "center" }}>
                          <Text>{row.label}</Text>
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={index} colSpan={1}>
                        <div>
                          <Text>{row.unit}</Text>
                        </div>
                      </Table.Summary.Cell>
                      {months.map((month, idxMonth) => {
                        const keyMonth = month.dataIndex;
                        const total = row[keyMonth as keyof typeof row] as number;
                        return (
                          <>
                            <Table.Summary.Cell index={idxMonth + index} colSpan={1}>
                              <div>
                                <Text>
                                  {total
                                    ? row.key === "intensity"
                                      ? parseAndFormatScientificNumber(`${total}`, 2)
                                      : parseAndFormatScientificNumber(`${total}`, 2)
                                    : 0}
                                </Text>
                                {/* <Text> {total ? formatNumber(total) : 0}</Text>  */}
                              </div>
                            </Table.Summary.Cell>
                          </>
                        );
                      })}

                      <Table.Summary.Cell index={19} colSpan={1}>
                        <div>
                          <Text>
                            {row.total
                              ? row.key === "intensity"
                                ? parseAndFormatScientificNumber(`${row.total}`, 2)
                                : parseAndFormatScientificNumber(`${row.total}`, 2)
                              : 0}
                          </Text>
                          {/* <Text>{row.total ? formatNumber(row.total) : 0}</Text> */}
                        </div>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ))}
                </Table.Summary>
              );
            }
          }}
        />
      )}

      <div style={{ paddingTop: "20px", justifyContent: "flex-end", display: "flex" }}>
        {selectedButton == "table" && profile?.roles.includes(roleCompanyAdmin) && (
          <Button type="primary" style={{}} onClick={handleOpenModalApproveMonth} disabled={isDisableSubmitButton()}>
            Submit
          </Button>
        )}
      </div>

      {openModalApproveMonth && (
        <ModalApproveMonth
          open={openModalApproveMonth}
          intitailMonthly={optionMonth}
          loading={loading || filterLoading}
          onSubmitReport={(checkedMonths) => {
            handleSubmitReport(checkedMonths);
          }}
          onCancelReport={() => {
            setOpenModalApproveMonth(false);
          }}
        />
      )}

      {openModalApproveStep && approveData && userId && selectedApprove && email && name && (
        <>
          {loading || filterLoading ? (
            <Spin style={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
          ) : (
            <ModalApproveStep
              data={approveData}
              userId={userId}
              approveId={selectedApprove}
              email={email}
              name={name}
              onApprove={(approveBody, action) => {
                handleApproveReport(approveBody, action);
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default ReportVocEmission;
